import { render, staticRenderFns } from "./CompareIcon.vue?vue&type=template&id=71605187&scoped=true&"
import script from "./CompareIcon.vue?vue&type=script&lang=js&"
export * from "./CompareIcon.vue?vue&type=script&lang=js&"
import style0 from "./CompareIcon.vue?vue&type=style&index=0&id=71605187&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71605187",
  null
  
)

export default component.exports